import React from 'react';

const Conferences = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Conferences</h1>
        <p>Upcoming and past AICIS conferences and summits</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-card">
              <h2>Upcoming Conferences</h2>
              <p>Register for our upcoming conference events.</p>
              <button className="btn-gold" onClick={() => window.location.href='/upcoming-conferences'}>View Upcoming</button>
            </div>
            <div className="content-card">
              <h2>Previous Conferences/Summits</h2>
              <p>Explore our past conference events and achievements.</p>
              <button className="btn-gold" onClick={() => window.location.href='/previous-conferences'}>View Previous</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Conferences;